import React from 'react';
import { cn } from '../../lib/utils';

// Age group → daily pitch limit
export const AGE_GROUP_LIMITS = {
  '7-8': 50,
  '9-10': 75,
  '11-12': 85,
  '13-16': 95,
};

// Rest days required based on pitches thrown
export const REST_DAYS = [
  { min: 66, max: Infinity, days: 4 },
  { min: 51, max: 65, days: 3 },
  { min: 36, max: 50, days: 2 },
  { min: 21, max: 35, days: 1 },
  { min: 1, max: 20, days: 0 },
];

export const getRestDays = (pitchCount) => {
  const rule = REST_DAYS.find(r => pitchCount >= r.min && pitchCount <= r.max);
  return rule ? rule.days : 0;
};

export const getPitchLimit = (ageGroup, customLimit) => {
  if (ageGroup === 'custom' && customLimit) return customLimit;
  return AGE_GROUP_LIMITS[ageGroup] || 85;
};

const getCountColor = (count, maxPitches) => {
  const max = maxPitches || 85;
  const pct = count / max;
  if (count >= max) return { bg: 'bg-red-600 animate-pulse', text: 'text-white', glow: 'shadow-red-500/60 shadow-lg', label: 'LIMIT' };
  if (pct >= 0.85) return { bg: 'bg-red-600', text: 'text-white', glow: 'shadow-red-500/50 shadow-lg', label: 'HIGH' };
  if (pct >= 0.60) return { bg: 'bg-amber-500', text: 'text-white', glow: 'shadow-amber-500/40 shadow-md', label: 'MED' };
  return { bg: 'bg-green-600', text: 'text-white', glow: '', label: '' };
};

export const PitchCountBadge = ({ count = 0, maxPitches, size = 'default', className = '' }) => {
  const style = getCountColor(count, maxPitches);
  const max = maxPitches || 85;

  if (size === 'large') {
    return (
      <div className={cn('flex flex-col items-center rounded-xl px-4 py-2', style.bg, style.glow, className)} data-testid="pitch-count-badge">
        <span className={cn('text-3xl font-extrabold leading-none', style.text)} style={{ fontFamily: 'Barlow Condensed, sans-serif' }}>
          {count}
        </span>
        <span className={cn('text-[10px] uppercase tracking-wider opacity-80', style.text)}>
          {maxPitches ? `of ${max}` : 'pitches'}
        </span>
      </div>
    );
  }

  return (
    <div className={cn('flex items-center gap-1.5 rounded-full px-3 py-1', style.bg, style.glow, className)} data-testid="pitch-count-badge">
      <span className={cn('text-lg font-extrabold', style.text)} style={{ fontFamily: 'Barlow Condensed, sans-serif' }}>
        {count}
      </span>
      <span className={cn('text-[10px] uppercase', style.text)}>
        {maxPitches ? `/ ${max}` : 'pitches'}
      </span>
    </div>
  );
};
